module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Article-w960.e51ee6bd.webp";